import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Select from "react-select";

import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";
import AsyncSelect from 'react-select/async';
import * as Picklist from "../Picklist";



function Master_local_expense() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [expensedata, setexpensedata] = useState([]);
    const [userRight, setUserRight] = useState([]);

    // master local expense head states - Guddu
    const [srNo, setSrNo] = useState(0);
    const [expense, setexpense] = useState('');
    const [account, setaccount] = useState({ id: '', label: '' });
    const [status, setStatus] = useState(1);
    const [remark, setRemark] = useState("");

    const [ldgSrchType, setLdgSrchType] = useState("");
    const [pdAccount, setPdAccount] = useState(null);
    const [piLocationValue, setPILocationValue] = useState(0);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [showFormBtn, setShowFormBtn] = useState(false);
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    // const [designationData, setDesignationData] = useState([]);
    const [piParty, setPIParty] = useState(null);
    const [pFSgst, setPFSgst] = useState("");
    const [tdsSection, setTdsSection] = useState("");
    const [tdsSrno, setTdsSrno] = useState(0);
    const [pTds, setPTds] = useState("");
    const [asyncTdsVal, setAsyncTdsVal] = useState();
    const [pdGroupValue, setPdGroupValue] = useState(0);
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [siLocationValue, setSILocationValue] = useState(0);
    const [siParty, setSIParty] = useState({ id: '', label: '' });
    const [siStateType, setSIStateType] = useState("");
    const [siStateName, setSIStateName] = useState("");
    const [hdrLocation, setHdrLocation] = useState(0);
    const [nStateSupplier, setNStateSupplier] = useState(null);
    const [siStateValue, setSIStateValue] = useState(0);
    const [siLocation, setSILocation] = useState(null);

    const productRef = useRef();



    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [formMode, setFormMode] = useState('Q'); // Q A E 
    const [msgTextYN, setMsgTextYN] = useState("");

    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [compareData, setCompareData] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [designationFilter, setDesignationFilter] = useState({ value: 0, label: "Select" });
    const [search, setSearch] = useState('');

    // account state managment
    const [accountvalue, setaccountvalue] = useState("");
    const [group, setgroup] = useState(null);





    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_EXPENSE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            $(".loader").show();
            setLoading(true);
            Common.callApi(Common.apiExpense, [sid, 'getList'], (result) => {
                setLoading(false);
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.status) {
                    setexpensedata(resp.data);
                } else {
                    setexpensedata([]);
                }
            });
            // Common.callApi(Common.apiDesignation, [sid, 'getSelect'], (result) => {
            //     let resp = JSON.parse(result);
            //     setDesignationData(resp);
            // });
            // Common.callApi(Common.apiCountry, [sid, 'getCnt'], function (result) {
            //     //     setCountryData(JSON.parse(result));
            //     // });
            //     //     setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const addNew = () => {
        setSrNo(0);
        setexpense('');
        setSIParty({ id: '', label: '' });
        setStatus(1);
        setFormMode('A');
        setShowAddNewBtn(false);
        setShowFormBtn(true);
    }

    const saveData = () => {
        if (expense === "") {
            setMsgText("Please fill Expense Value!");
            setMsgBox(true);
        } else if (formMode === 'E' && remark === '') {
            setMsgText('Please fill Remark!');
            setMsgBox(true);
        } else {
            var obj = {
                expense: expense,
                group: group,
                account: accountvalue,
                status: status,
                trantype: 'MEXP',
                trannumber: srNo,
                trancategory: 'M',
                activitytype: srNo * 1 > 0 ? 'MODIFY' : 'CREATE',
                remark: remark,
                branch: 0
            };

            const infoObject = Common.compareArrays(compareData, [obj]);

            if (userRight.edit === "1" && formMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'MEXP'));
            }
            $(".loader").show();
            Common.callApi(Common.apiExpense, [sid, 'savelist', srNo, JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                let resp = JSON.parse(result);
                if (resp.status) {
                    $(".loader").hide();
                    setShowFormBtn(false);
                    setShowAddNewBtn(true);
                    setRemark("");
                    setexpensedata(resp.data);
                    setMsgText(resp.message);
                    setMsgBox(true);

                    setTranAuditTrail([]);
                } else {
                    setMsgText(resp.message);
                    setMsgBox(true);
                }
            });
        }
    }

    const cancelConfirm = () => {
        setaccount({ id: '', label: '' });
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);


        } else if (formMode == 'Q') {
            setexpense('');
            setaccount(null);
            setStatus(1);
            cancelData();
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setShowFormBtn(false);
        setShowAddNewBtn(true);
        setShowActivityLog(false);
    }

    // const cancelData = () => {
    //     setShowFormBtn(false);
    //     setShowAddNewBtn(true);
    // }
    const fillViewCompareObject = (resp) => {
        // console.log('res of fill view obj: ', resp);
        const obj2 = {
            srNo: resp.mleh_srno,
            expense: resp.mleh_expense,
            account: resp.mvli_ledger_name,
            status: resp.mleh_status,
        };
        setCompareData([obj2]);
    }

    const fillEditForm = (id) => {
        setFormMode('Q');
        setShowActivityLog(false);
        Common.callApi(Common.apiExpense, [sid, 'viewList', id], (result) => {
            let resp = JSON.parse(result);
            fillViewCompareObject(resp);
            setgroup(resp[0].mleh_group)
            setaccountvalue(resp[0].mleh_account)
            setSrNo(resp[0].mleh_srno);
            setexpense(resp[0].mleh_expense);
            setSIParty({
                id: `^${resp[0].mleh_group}^${resp[0].mleh_account}^${resp[0].mvli_ledger_name}`,
                label: `${resp[0].mleh_group} ${resp[0].mleh_account} ${resp[0].mvli_ledger_name}`
            })
            setStatus(resp[0].mleh_status);
            setShowAddNewBtn(false);
            setShowFormBtn(true);
        });
    }

    const editData = () => {
        setFormMode('E');
    }

    const exportFile = () => {
        var obj = {
            right: 'MASTER_EXPENSE',
            SrNo: srNo,
            Group: group,
            Account: accountvalue,
            Expense: expense,
            Status: status
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MEXP", trannumber: srNo, trancategory: "M" });
    }


    const handelFilterList = (e) => {
        // console.log("search: ", search)
        e.preventDefault();
        let filterData = {
            searchtype: search.trim()
        }

        Common.callApi(Common.apiExpense, [sid, 'getList', JSON.stringify(filterData)], (result) => {
            setLoading(false);
            let resp = JSON.parse(result);
            // console.log("res from backend: ", resp);
            $(".loader").hide();
            if (resp.status) {
                setexpensedata(resp.data);
            }
            else {

                setexpensedata([]);
            }
        });
    }

    const handleProductAccountChange = (value) => {
        //Console.log(value);
        setSIParty(value);
        const idArray = value.id.split('^');
        setgroup(value.id.split('^')[1])
        setaccountvalue(value.id.split('^')[2])
        setPIParty(value);
        if (idArray[9] !== "") {
            setPTds(idArray[9])
        } else {
            setPTds("0");
        }
        //index 10->tds_section,11->percentage
        setTdsSection(idArray[10]);
        setTdsSrno(idArray[12]);
        setPTds(idArray[11]);
        setAsyncTdsVal({ id: '^ ^' + idArray[10] + '^' + idArray[11], value: idArray[10] + ' ' + idArray[11] })
    }


    const handleLocationChange = (value) => {
        //Console.log("this is location Value", value);
        setSILocation(value);

        var id = value.id;
        var location = id.split("^");

        setSILocationValue(location[1]);
        setSIStateValue(location[3] == null ? 0 : location[3]);
        setSIStateType(location[4]);
        setSIStateName(location[5] === "" ? "Select" : location[5]);
        setHdrLocation(location[2]);

        setNStateSupplier({
            id: location[3] == null ? 0 : location[3],
            label: location[5] === "" ? "Select" : location[5]
        });

        sessionStorage.activeBranch = location[1];
    };

    return (
        <>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h1> Master Local Expense </h1>
                    </Col>
                </Row>
                {
                    showAddNewBtn ?
                        <>
                            <Row >
                                <Col className='col-md-4 col-4'>
                                    <Form.Group >
                                        <Form.Label>Search</Form.Label>
                                        <Form.Control type='text' placeholder='Search By Expense OR Ledger Name' maxLength="100" value={search}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSearch)}
                                        />
                                    </Form.Group>
                                </Col>
                                {/* <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Form.Label>Designation</Form.Label>
                                        <Select options={designationData} value={designationFilter} onChange={v => setDesignationFilter(v)} />
                                    </Form.Group>
                                </Col> */}
                            </Row>
                            <Row style={{ marginTop: 40 }}>
                                <Col>
                                    {userRight.add === "1" ?
                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={addNew}>Add New</Button>
                                        : null
                                    }&nbsp;
                                    <Button variant='outline-primary' className='buttonStyle' type="button" size='sm' onClick={handelFilterList}  >List</Button>&nbsp;
                                    {
                                        userRight.query === "1" ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>&nbsp;
                                            </>
                                            : null
                                    }
                                </Col>



                            </Row>
                        </>
                        : null
                }
                <Row><Col>&nbsp;</Col></Row>
                {
                    showFormBtn ?
                        <>
                            <Row>
                                <Col className="divContentCenter">
                                    <div className="maxFormWidth">
                                        <Form>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Serial Number</Form.Label>
                                                        <Form.Control type="text" placeholder="Serial Number" value={srNo}
                                                            disabled />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Expense<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Expense" maxLength={100}
                                                            value={expense}
                                                            onChange={(e) => Common.validateAlpValue(e.target.value, setexpense)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='col-md-6 col-12'>
                                                    <Form.Group>
                                                        <Form.Label>Account<span className='colorThemeRed'>*</span></Form.Label>
                                                        <AsyncSelect
                                                            placeholder="Select an option..."
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={siParty}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, siLocationValue)} // location = 1 , 2
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleProductAccountChange}
                                                            isDisabled={formMode === "Q"}
                                                            ref={productRef}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Status</Form.Label>
                                                        <Form.Select value={status} onChange={e => setStatus(e.target.value)} disabled={formMode === 'Q'} required>
                                                            <option value="1">ACTIVE</option>
                                                            <option value="0">INACTIVE</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>&nbsp;</Col>
                                            </Row>
                                            {
                                                formMode === 'E' ?
                                                    <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group>
                                                                    <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                                    <Form.Control type="text" placeholder="Remark" maxLength={50}
                                                                        value={remark}
                                                                        onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                                        autoComplete="off"
                                                                        required />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col>&nbsp;</Col>
                                                            <Col>&nbsp;</Col>
                                                            <Col>&nbsp;</Col>
                                                        </Row>
                                                    </> :
                                                    null
                                            }
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                        saveData()}>Save</Button>&nbsp;
                                                    <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                        cancelData()}>Cancel</Button> */}

                                                    <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                        cancelConfirm()}>Back</Button>&nbsp;&nbsp;

                                                    {
                                                        (userRight.edit === "1" && formMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                editData()}>Edit</Button>&nbsp;
                                                        </> : null
                                                    }
                                                    {
                                                        (userRight.edit === "1" && formMode === 'E') || (userRight.add === "1" && formMode === 'A') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                saveData()}>Save</Button>&nbsp;
                                                        </> : null
                                                    }
                                                    {
                                                        (userRight.query === "1" && (formMode === 'E' || formMode === 'Q')) ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                    }
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                            {/* <Row>
                                {
                                    showActivityLog &&
                                    <>
                                        <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
                                    </>
                                }
                            </Row> */}
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th className="textRight">Sr No</th>
                                                <th>Expense</th>
                                                <th>Ledger Name</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {

                                                loading ? (
                                                    null

                                                ) : expensedata.length > 0 ? (expensedata.map((res) => (
                                                    <tr key={res.mleh_srno}>
                                                        {userRight.edit === "1" ?
                                                            <td className="textCenter" >
                                                                <span className="handCursor" onClick={() => fillEditForm(res.mleh_srno)} >
                                                                    <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                </span>
                                                            </td>
                                                            : null
                                                        }
                                                        <td className="textRight">{res.mleh_srno}</td>
                                                        <td>{res.mleh_expense}</td>
                                                        <td>{res?.mleh_group + ' ' + res?.mleh_account + ' ' + res?.mvli_ledger_name}</td>
                                                        <td>{res.mleh_status == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                                    </tr>
                                                ))) : (

                                                    <tr>
                                                        <td colSpan="4" className="textCenter">Data not found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                }
            </Container >
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            {/* <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div> */}
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </>
    )
}

export default Master_local_expense;
